import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/marketing/search-seo")({
  component: () => <Outlet />,
});
